import React, { useState } from "react";
import "./css/forgotpassword.css";
import { FaEnvelope } from "react-icons/fa";
import Header from "../components/LandingComponents/Header";
import LandingFooter from "../components/LandingComponents/LandingFooter";
import { toast } from "sonner";
import { useNavigate, Link } from "react-router-dom";
import { useForgotPasswordMutation } from "../slices/userApiSlice"; // Import API Hook

const Forgotpassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation(); // Mutation Hook

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Error: Please enter your email address");
      return;
    }

    try {
      const toastId = toast.loading("Sending OTP...");

      await forgotPassword(email).unwrap(); // API Call

      toast.dismiss(toastId);
      toast.success("Success: OTP has been sent to your email");
      navigate("/otp", { state: { email } });
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error?.data?.message ||
          "Error: Failed to send OTP. Please try again later.",
      );
    }
  };

  return (
    <div className="login-wrapper">
      <Header />
      <div className="login-main">
        <div className="login-bg-overlay"></div>

        <div className="login-card">
          <div className="login-card-header">
            <h2 className="login-title">Reset Password</h2>
            <p className="login-subtitle">
              Enter your official email address to receive a verification code.
            </p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label className="login-label">Email Address</label>
              <div className="login-input-wrapper">
                <FaEnvelope className="login-field-icon" />
                <input
                  required
                  type="email"
                  placeholder="name@example.com"
                  className="login-input"
                  value={email}
                  onChange={handleEmailChange}
                  disabled={isLoading}
                />
              </div>
            </div>

            <button
              type="submit"
              className="login-btn-primary"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send Verification Code"}
            </button>
          </form>

          <div className="login-card-footer">
            <Link to="/login" className="login-back-link">
              <span>Back to Login</span>
            </Link>
          </div>
        </div>
      </div>
      <LandingFooter />
    </div>
  );
};

export default Forgotpassword;
